import React from 'react';
import styled from 'styled-components';
const defaultAlign = 'flex-start';
const defaultSpacing = 10;
function getAlign(props) {
    switch (props.align) {
        case 'left':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return defaultAlign;
    }
}
function getBottomMargin(props) {
    return `${props.spacing ?? defaultSpacing}px`;
}
const Container = styled.div `
  width: 100%;
  display: flex;
`;
const Stack = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${getAlign};

  > * {
    margin: 0;
    margin-bottom: ${getBottomMargin};
  }

  margin-bottom: -${getBottomMargin};
`;
/**
 * VStack is useful for controlling the amount of
 * space "between" elements in a vertical layout.
 *
 * Note: This will override margins of all direct
 * children in order to produce desired spacing.
 */
export const VStack = (props) => (React.createElement(Container, { className: "vstack-container" },
    React.createElement(Stack, { ...props, className: "vstack-stack" })));
